import { AdContainer } from '../../../ad-container/ad-container';
import {
  ViewabilityEventConditions,
  ViewabilityEnvironment
} from '../../../enums';
import { ViewabilityObserver } from '../../../types/viewability-observer';

const VIEWABLE_THRESHOLD_50_PERCENTS = 50;
const VIEWABLE_THRESHOLD_100_PERCENTS = 100;

export class MraidObserverService implements ViewabilityObserver {
  readonly environment: ViewabilityEnvironment = ViewabilityEnvironment.InApp;
  private readonly listeners: Record<
    ViewabilityEventConditions,
    Array<() => void>
  > = {
    [ViewabilityEventConditions.On50PercentVisible]: [],
    [ViewabilityEventConditions.On100PercentVisible]: [],
    [ViewabilityEventConditions.OnNotVisible]: []
  };

  private readonly exposureChangedPointer = this.onExposureChanged.bind(this);

  constructor(private readonly adContainer: AdContainer) {}

  observe(element: HTMLElement) {
    this.disconnect();
    this.attachEvents();
  }

  on(event: ViewabilityEventConditions, callback: () => void) {
    this.listeners[event].push(callback);
  }

  disconnect() {
    this.adContainer.detachExposureChangedListener();
  }

  private attachEvents(): void {
    this.adContainer.onExposureChanged(this.exposureChangedPointer);
  }

  private callListeners(condition: ViewabilityEventConditions): void {
    this.listeners[condition].forEach(cb => cb());
  }

  private onExposureChanged(exposure: number): void {
    if (
      exposure >= VIEWABLE_THRESHOLD_50_PERCENTS &&
      exposure < VIEWABLE_THRESHOLD_100_PERCENTS
    ) {
      this.callListeners(ViewabilityEventConditions.On50PercentVisible);
    } else if (exposure >= VIEWABLE_THRESHOLD_100_PERCENTS) {
      this.callListeners(ViewabilityEventConditions.On50PercentVisible);
      this.callListeners(ViewabilityEventConditions.On100PercentVisible);
    } else {
      this.callListeners(ViewabilityEventConditions.OnNotVisible);
    }
  }
}
